const axios = require('axios').default;

const courseCode = {
        dataUrl: '',
        apiToken: '',
        apiClient: '',
        configLoaded: false,

    _getConfig() {
        return {
            headers: {
                'X-API-ClientName': this.apiClient,
                'X-API-Token': this.apiToken
            }
        };
    },
    _getDataYears( callback ){
        axios.get(this.dataUrl + 'subject/datayears', this._getConfig() )
            .then(function(response){
                callback(response.data.data);
            })
            .catch(function(error){
                console.log(error);
            });
    },
    getDataYears( callback ){
            var app = this;
            if ( !app.configLoaded ) {
                app.loadConfig(function(){
                    app.configLoaded = true;
                    callback( app._getDataYears( callback ) )
                })
            } else {
                callback( app._getDataYears( callback ) )
            }
    },
    getSubjects(datayears, page, limit,  callback){
        axios.get(this.dataUrl + 'subject?datayears=' + datayears +'&limit=' + limit + '&page=' + page, this._getConfig() )
            .then(function(response){
                callback(response.data.data);
            })
            .catch(function(error){
                console.log(error);
            });
    },
    getCoursesBySubject(datayears, subject, page, limit, callback) {
            if ( subject === 'all' || subject==='all-meet' || subject === 'all-nomeet' ) subject ='';
        axios.get(this.dataUrl + 'subject/'+ subject + '?datayears=' + datayears +'&limit=' + limit + '&page=' + page + '&includecourses=true', this._getConfig() )
            .then(function(response){
                callback(response.data.data.courses);
            })
            .catch(function(error){
                console.log(error);
            });
    },
    getCoursesBySubjectURL(datayears, subject, callback) {
        return  this.dataUrl + 'subject/'+ (subject ? subject : 'all' ) + '/list.csv?datayears=' + datayears +'&includecourses=true'
    },
    getCoursesBySubjectCollection(datayears, subjects, page, limit, callback) {
            let requests = [];
            for ( let x in subjects ) {
                requests[ x ] =  axios.get(this.dataUrl + 'subject/'+ subjects[x] + '?datayears=' + datayears +'&limit=' + limit + '&page=' + page + '&includecourses=true', this._getConfig())
            }

            axios.all( requests ).then( responseArr =>{
                let courseBySubject = {};
                for ( let x in subjects ) {
                    courseBySubject[ subjects[x] ] = responseArr[x].data.data;
                }
                callback(courseBySubject);
            });
    },
    loadConfig(callback){
        var app = this;
        axios.get( 'config.json' )
            .then(function(response){
                if ( response.status === 200 ) {
                    if ( response.data.apiClient ) {
                        app.apiClient = response.data.apiClient
                    }
                    if ( response.data.apiToken ) {
                        app.apiToken = response.data.apiToken
                    }
                    if ( response.data.dataUrl ) {
                        app.dataUrl = response.data.dataUrl
                    }
                }

                if ( callback ) callback(response)

            })
            .catch(function(error){
                console.log(error);
            });
    }
};

export default courseCode;



